import { render, staticRenderFns } from "./CampaignAdd.vue?vue&type=template&id=37b9d760&scoped=true"
import script from "./CampaignAdd.vue?vue&type=script&lang=js"
export * from "./CampaignAdd.vue?vue&type=script&lang=js"
import style0 from "./CampaignAdd.vue?vue&type=style&index=0&id=37b9d760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b9d760",
  null
  
)

export default component.exports